import { useRecoilTransaction_UNSTABLE } from 'recoil';

import { consultationAtoms, filterAtoms, searchAtoms, searchSortState } from 'store';

export const useResetSearchState = (): (() => void) =>
  useRecoilTransaction_UNSTABLE(({ reset }) => () => {
    Object.values(consultationAtoms).forEach((atom) => reset(atom));
    Object.values(filterAtoms).forEach((atom) => reset(atom));
    Object.values(searchAtoms).forEach((atom) => reset(atom));
    reset(searchSortState);
  });
